<!-- Department header -->
<app-dept-header *ngIf="showDeptMenu"></app-dept-header>

<!-- Page Content -->
<div id="page-content">
  <div class="container">
    <div class="row">
      <!--MAIN Content-->
      <div class="col-md-8">
        <div id="page-main">
          <section class="events grid" id="events">
            <header><h1>News</h1></header>
            <div class="row">

              <div class="col-md-6 col-sm-6" *ngFor="let news of allNewsData let i=index">
                <article class="event">
                  <a routerLink="/info/{{news.id}}">
                    <figure class="date">
                      <div class="month">{{ news.commence_date | date:'MMMM' }}</div>
                      <div class="day">{{ news.commence_date | date:'d' }}</div>
                    </figure>
                  </a>
                  <aside>
                    <header>
                      <a routerLink="/info/{{news.id}}">
                        {{news.title}}
                      </a>
                    </header>

                    <div class="additional-info"><span class="fa fa-calendar"></span>
                      <span> {{ news.commence_date | date:'MMMM d, y' }}</span>
                      <span *ngIf="news.complete_date != news.commence_date">
                        to {{ news.complete_date | date:'MMMM d, y' }}
                      </span>
                    </div>

                    <div class="description">
                      <p>{{news.short_desc}}</p>
                    </div>
                  </aside>
                </article><!-- /article -->
              </div><!-- /.col-md-6 -->

            </div><!-- /.row -->
          </section><!-- /.events grid -->
        </div><!-- /#page-main -->
      </div><!-- /.col-md-8 -->

      <!--SIDEBAR Content-->
      <div class="col-md-4">
        <div id="page-sidebar" class="sidebar">
          <aside class="news-small" id="news-small">
            <header>
              <h2>All News</h2>
            </header>
            <div class="section-content">

              <article *ngFor="let newsItem of allNewsData">
                <figure class="date"><i class="fa fa-calendar"></i>{{ newsItem.commence_date | date:'MMMM d, y' }}</figure>
                <header>
                  <a routerLink="/info/{{newsItem.id}}" routerLinkActive="active">
                    {{newsItem.title.slice(0,50)}}...
                  </a>
                </header>
              </article><!-- /article -->

            </div><!-- /.section-content -->
          </aside><!-- /.news-small -->

        </div><!-- /#sidebar -->
      </div><!-- /.col-md-4 -->
    </div><!-- /.row -->
  </div><!-- /.container -->
</div>
<!-- end Page Content -->
